import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">Husselochtend organiseren</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">Husselochtend organiseren bij je tennisclub</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">Een <strong>husselochtend</strong> is op veel tennisverenigingen het populairste moment van de week — minder druk dan de avond, en perfect voor senioren, thuiswerkers en ouders. Hoe organiseer je dat zonder dat een vrijwilliger elke week om 09:00 op de baan moet staan?</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Waarom een husselochtend?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Banen zijn overdag minder druk — meer keuze in tijdsloten.</li><li>Sociaal moment voor leden die niet werken of vrij zijn.</li><li>Vaak een vaste, trouwe groep — minder no-shows dan ’s avonds.</li><li>Geschikt voor combinatie met koffie/lunch in de kantine.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Wat is anders dan een husselavond?</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><p>Inhoudelijk niets — de speelvorm is identiek. Het enige verschil zit in <strong>doelgroep en planning</strong>:</p><ul class="list-disc pl-6 space-y-1"><li>Doelgroep: vaak senioren of niet-werkenden.</li><li>Tijdsblok: meestal 09:00–12:00.</li><li>Vaak iets langere rondes (30–45 minuten).</li><li>Meer ruimte voor pauze met koffie tussendoor.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Stappenplan</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ol class="list-decimal pl-6 space-y-1"><li>Reserveer de banen voor de ochtend.</li><li>Maak in De Hussel App een sessie aan met starttijd en rondes.</li><li>Leden melden zich aan via hun telefoon.</li><li>Het algoritme deelt automatisch in — push-meldingen bij iedere ronde.</li></ol><p>Volledige uitleg: <a href="/husselavond-organiseren" class="text-accent hover:underline">husselavond organiseren</a>.</p></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Werkt De Hussel App ook overdag?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. De app werkt voor elk tijdsblok — ochtend, middag of avond. Je stelt zelf starttijd en eindtijd in.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Wat is een goede starttijd voor een husselochtend?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">De meeste clubs draaien tussen 09:00 en 12:00. Eerder starten kan, maar zorg dat banen voldoende warm/droog zijn (gravelclubs: vegen vooraf).</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoe lang duurt een husselochtend gemiddeld?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">2 tot 3 uur, met meestal 4 tot 6 rondes van 30 minuten. Aan het einde napraten met koffie.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Kan dit ook voor de jeugd in de schoolvakantie?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. In de vakantieperiodes draaien veel clubs jeugd-husselochtenden. Lees: jeugd-husselavond organiseren.</div>
    </details></div>
    </div>
  </section>`;

const HusselochtendOrganiseren = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default HusselochtendOrganiseren;
